import { Link } from "react-router-dom";

import styles from "./DashboardWelcomeItem.module.css";

const DashboardWelcomeItem = ({
    title,
    description,
    links,
    icon: Icon,
    isFullWidth,
}) => {
    return (
        <div
            className={`${styles.dashboardWelcomeItem} ${isFullWidth ? styles.fullWidth : ""}`}
        >
            {Icon && (
                <div className={styles.dashboardWelcomeIcon}>
                    <Icon />
                </div>
            )}
            <div className={styles.dashboardWelcomeContent}>
                <h2 className={styles.dashboardWelcomeTitle}>{title}</h2>
                <p className={styles.dashboardWelcomeDescription}>
                    {description}
                </p>
                {links &&
                    links.map((link, index) =>
                        link.isExternal ? (
                            <a
                                key={index}
                                href={link.url}
                                className={styles.dashboardWelcomeLink}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {link.text}
                            </a>
                        ) : (
                            <Link
                                key={index}
                                to={link.url}
                                className={styles.dashboardWelcomeLink}
                            >
                                {link.text}
                            </Link>
                        ),
                    )}
            </div>
        </div>
    );
};

export default DashboardWelcomeItem;
